/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { BodyText, Icon } from '@postscript/components';
import { getSystemMessageIcon } from 'components/responses/utils/messages';
import parseMessageForHtml from 'components/responses/utils/parseMessageForHtml';
import parseMessagesForPreview from 'components/responses/utils/parseMessageForPreview';
import styled from 'styled-components';
import { SYSTEM_EVENT_SALES_AI_SUBSTRING, ViewOptions } from '../constants';
import { useView } from '../hooks/useView';
import { Message } from '../types';
import { canViewSystemMessage } from '../utils/roles';
import ClassificationSystemMessage from './ClassificationSystemMessage';

interface MessageProps {
  message: Message;
}

const MessageFlexWrapper = styled.div`
  display: flex;
  gap: 3px;
  padding: 3px var(--spacing-5);
  width: 100%;
  backdrop-filter: blur(1px);
`;

const parseMessageText = (message: string) =>
  parseMessageForHtml(parseMessagesForPreview(message));

const SystemMessage = ({ message }: MessageProps): JSX.Element => {
  const { view } = useView();
  if (!canViewSystemMessage(message, view as ViewOptions)) {
    return <></>;
  }

  const isClassificationEvent = message?.type?.includes(
    SYSTEM_EVENT_SALES_AI_SUBSTRING,
  );

  return (
    <MessageFlexWrapper>
      <Icon
        color="var(--gray-5)"
        component={getSystemMessageIcon(message.text || '')}
        size={18}
      />
      <BodyText as="span" size="x-small">
        {isClassificationEvent ? (
          <ClassificationSystemMessage message={message} />
        ) : (
          parseMessageText(message.text)
        )}
      </BodyText>
    </MessageFlexWrapper>
  );
};

export default SystemMessage;
